// Figma "cases" > Feyenoord, section 71:6303, frames in screen order:
// 71:6304 (cover), 71:6339, 71:6366
import type { Case, Img } from "../types"

const own = (n: string, w: number, h: number): Img => {
    const src = `/work/feyenoord/${n}`
    return { id: src, src, w, h, widths: [...[800, 1600].filter((x) => x < w), w] }
}
const IMG = own
// the videos' first frames
const HOME: Img = { id: "/work/feyenoord/c-home", src: "/work/feyenoord/c-home", w: 1920, h: 1200, widths: [800, 1600, 1920] }
const MATCH: Img = { id: "/work/feyenoord/c-match", src: "/work/feyenoord/c-match", w: 750, h: 1624, widths: [750] }

export const feyenoord: Case = {
    name: "Feyenoord",
    theme: {
        page: "#000000",
        gradient: "linear-gradient(180deg, #000000 0%, #bd131a 100%)",
        stops: [
            [0, 0, 0, 0],
            [189, 19, 26, 1],
        ],
        fill: "#000000",
        line: "#ea272e",
        tone: "dark",
        title: "#ffffff",
        body: "rgba(255, 255, 255, 0.6)",
    },
    modules: [
        // 1: a brick layout, as DEPT Festival's cover: the top photo (888 wide)
        // spans the card's column and half of the next; the site still (888, on a
        // #0f0f0f panel) starts under its middle, as high as the card beside it.
        // Columns at the cells' edges: 220, 443, 442, 443.
        {
            type: "bricks",
            cols: [220, 443, 442, 443],
            rows: [400, 443],
            cells: [
                {
                    at: [0, 0],
                    h: 220,
                    tag: {
                        logo: "/work/feyenoord/logo.svg",
                        logoBox: [20, 20, 53, 53],
                        // (Figma's node 71:6338 still had Inter's lines)
                        text: "FEYENOORD ROTTERDAM\nFOOTBALL CLUB\nFOUNDED 1908\n\n.COM AND APP",
                    },
                },
                { at: [1, 0, 2], h: 400, image: IMG("1-1", 1776, 800) },
                {
                    at: [1, 1],
                    h: 443,
                    card: {
                        title: "Facelifting\nthe giant of\nRotterdam",
                        body: "Concept designs created for Feyenoord during a pitch phase for their new .com and app. Incorporated with the newly crafted identity by Studio Dumbar.",
                    },
                },
                // site still (node 71:6333 "image 271", 750 x 396 at 69, 47 on the panel): a frame of the desktop home page
                { at: [2, 1, 2], h: 443, cls: "pos-ui", image: IMG("1-2", 1776, 886), phone: false },
            ],
        },
        // 2: video panel left 1111 + portrait photo right 443
        {
            type: "grid",
            columns: [
                { w: 1111, cells: [{ h: 846, keep: true, image: HOME, clip: { src: "/work/feyenoord/c-home", box: [72, 121, 967, 604], bg: "#0f0f0f" } }] }, // video: node 71:6364, desktop site 967 x 604 (1.6:1) inset at 72, 121 on a #0f0f0f panel (71:6363); screenshot black
                { w: 443, cells: [{ h: 652, image: IMG("2-1", 886, 1304) }, { h: 191 }] },
            ],
        },
        // 3: photo bottom-left 548 + phone video panel 454 + aerial photo top-right 548
        {
            type: "grid",
            phoneCenter: true,
            columns: [
                { w: 548, cells: [{ h: 279 }, { h: 564, image: IMG("3-1", 1096, 1128), phone: false }] },
                { w: 454, cells: [{ h: 846, phone: false, image: MATCH, clip: { src: "/work/feyenoord/c-match", box: [63, 68, 327, 709, 30], bg: "#0f0f0f" } }, { h: 846, desktop: false, keep: 750 / 1624, image: MATCH, clip: { src: "/work/feyenoord/c-match" } }] }, // video (phones: only it, filling the module): node 71:6393, phone screen 327 x 709 (radius 30) inset at 63, 68 on a #0f0f0f panel (71:6392); screenshot black
                { w: 548, cells: [{ h: 463, image: IMG("3-2", 1096, 926), phone: false }, { h: 380 }] },
            ],
        },
    ],
}
